import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, NavigationExtras } from '@angular/router';
import { DspxCardSetBaseFormComponent, SpinnerService, DialogService, CoreService } from 'dspx-core';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { VptasSubsidyGridFilterRequest } from 'src/app/interfaces/vptas-subsidy-grid-filter-request.interface';
import { POP_UP_CODES } from 'src/app/constants/app-data.constants';
import { finalize, take } from 'rxjs';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';

@Component({
  selector: 'app-vptas-application-subsidy-list',
  templateUrl: './vptas-application-subsidy-list.component.html',
  styleUrl: './vptas-application-subsidy-list.component.scss'
})
export class VptasApplicationSubsidyListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value;
  }

  applicationId: string = '';
  activeDialog: string = '';

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService,
    private errorService: ErrorService,
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.victorianPatientTransportAssistanceSchemeApplicationSubsidyList,
      () => {
        return API_ENDPOINTS.dashboard.getVptasApplicationSubsidies;
      },
      false);
  }

  ngOnInit(): void {
    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const applicationId = paramMap.get('id');
        if (applicationId) {
          this.applicationId = applicationId;
        }
      })
    );
      
    this.coreService.applicationFunctions = {
      exit: () => this.navigateBack(),
    };
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  filterData(event: any): void {
  }
  
  formLoad(event: any): void {
    this.loadGridDataOnFormLoad(this.getAdjustmentFilterRequest());
  }

  actionButton_subsidyGrid_datagrid_createAdjustment_Clicked(event: any): void {
    this.activeDialog = POP_UP_CODES.vptasApplicationSubsidyList.addAdjustment;
    this.dialogService.showPopup(this.activeDialog, { id: event.event.data.id });
  }

  actionButton_subsidyGrid_datagrid_edit_Clicked(event: any): void {
     this.router.navigate(['/', ROUTE_CONSTANTS.vptasApplication.prefix, this.applicationId, 'subsidy', event.event.data.id]);
  }

  actionButton_subsidyGrid_datagrid_custom_createSubsidy_Clicked(event: any): void {
    const isApplicationRewinded = this.getQuestionValue(this.model, 1, 1, 'subsidySection', 'isApplicationRewinded');
    if (!isApplicationRewinded) {
      this.dialogService.showPopup(POP_UP_CODES.vptasApplicationSubsidyList.createSubsidyRewindWarning);
    } else {
      this.router.navigate(['/', ROUTE_CONSTANTS.vptasApplication.prefix, this.applicationId, 'subsidy']);
    }    
  }

  dialogButton_addAdjustment_Clicked(event: any): void {
    const subsidyAdjustmentAmount = this.parseDecimalAmount(event.subsidyAdjustmentAmount);

    if (subsidyAdjustmentAmount === null) {
      this.dialogService.showPopup(POP_UP_CODES.vptasApplicationSubsidyList.addAdjustmentDecimalWarning, null);
    }
    else {
      this.spinnerService.showSpinner();
      this.appDataService
        .post(API_ENDPOINTS.vptasApplicationDetails.addAdjustmentToSubsidy,
          {
            id: event.id,
            subsidyAdjustedAmount: subsidyAdjustmentAmount,
            adjustmentReason: event.adjustmentReason
          })
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe((data) => {
          this.loadGridDataOnFormLoad(this.getAdjustmentFilterRequest());
        });
    }
  }

  private parseDecimalAmount(value: unknown): number | null {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    if (typeof value !== 'string') {
      return null;
    }

    const sanitisedValue = value.trim().replace(/[$,\s]/g, '');

    if (!/^-?\d+(\.\d+)?$/.test(sanitisedValue)) {
      return null;
    }

    const parsedValue = parseFloat(sanitisedValue);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  private getAdjustmentFilterRequest(): VptasSubsidyGridFilterRequest {
    return {
      ApplicationId: this.applicationId
    };
  }

  private navigateBack() {
    const navExtras = this.getNavigationExtras();
    this.router.navigate(['/', ROUTE_CONSTANTS.vptasApplication.prefix, ROUTE_CONSTANTS.vptasApplication.details.prefix, this.applicationId], navExtras);
  }

  private getNavigationExtras(): NavigationExtras {
    return {
      state: {
        applicationFilterRequest: history.state.applicationFilterRequest,
        }
      };
  }
}
